import { FETCH_DETAILS, FETCH_MANAGE_METRICS } from "src/shared/config";
import { ISingleManageMetrics } from "src/shared/models/ManageMetricsModel";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getXClientIdHeader } from "src/utils/getservicename";

type GetManageMetric = {
  metricId: string;
  timeTab: string;
  shouldFetchFreshData?: boolean;
};

const headers = { "Content-Type": "application/json" };

export const getManageMetrics = (): ApiResponse =>
  appFetch.get(FETCH_MANAGE_METRICS, {
    params: { isNotesEnabled: "false" },
  });

export const updateManageMetrics = (data: ISingleManageMetrics[]): ApiResponse =>
  appFetch.put(FETCH_MANAGE_METRICS, {
    body: data,
    headers,
    isRawResponse: true,
    statusMessageConfig: {
      2: "Metrics were updated successfully",
      4: "There was some error updating metrics. Please try again",
    },
  });

export const getManageMetric = ({ metricId, timeTab, shouldFetchFreshData }: GetManageMetric): ApiResponse => {
  const headers = shouldFetchFreshData ? { "X-Clear-Cache": "true", ...getXClientIdHeader() } : getXClientIdHeader();
  return appFetch.get(`${FETCH_MANAGE_METRICS}/${metricId}`, {
    params: { timeTab },
    headers,
  });
};

export const getManageMetricDetails = ({ metricId, timeTab, shouldFetchFreshData }: GetManageMetric): ApiResponse => {
  const headers = shouldFetchFreshData ? { "X-Clear-Cache": "true", ...getXClientIdHeader() } : getXClientIdHeader();
  return appFetch.get(`${FETCH_DETAILS}/${metricId}`, {
    params: { timeTab },
    headers,
  });
};
